import { Box, Grid, Typography } from "@mui/material";
import { ColItem } from "./colItem";
import "./col.css";
import { useState } from "react";
import { r13 } from "../utils/utils";
import { UiControls } from "./uicontrols";
import { ItemDetails } from "./itemDetails";

export const CollectionLog = (itemList, quantity) => {
  if (!itemList) {
    itemList = [];
  }
  var j = itemList.itemList;
  var whichView = itemList.view;

  var [iteminfo, setIteminfo] = useState({ name: "xxxxxxxxx" });
  var [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  var foundLog = itemList.foundLog;

  var foundTotal = 0;
  for (var f = 0; f < foundLog.length; f++) {
    if (foundLog[f] !== null) {
      foundTotal++;
    }
  }

  var [statsState, setStatsState] = useState('closed');

  const handleExpand = (whatIs) => {
    console.log('handleExpand ' + whatIs);
    setStatsState(whatIs);
  };

  var hoverCallBack = function (inputs) {
    setIteminfo(inputs);
  };

  var hoverEndCallBack = function () {
    setIteminfo({ name: "xxxxxxxxx" });
  };

  var getStringFromIndex = (theIndex) => {
    var newIndex = theIndex + 1;
    if (newIndex <= 9) return "#000" + newIndex;
    if (newIndex <= 99) return "#00" + newIndex;
    if (newIndex <= 999) return "#0" + newIndex;
    if (newIndex <= 9999) return "#" + newIndex;
  };

  if (statsState == 'closed') {
    return (
      <Box className="inv">
        <Box className="invTitleHolder">
          <Grid container className={'spanRowT quava'} spacing={{ xs: 0, md: 0 }}>
            <Typography textAlign={"center"} variant="h5" className={'title80'}>
              Collection Log
            </Typography>
            <Typography textAlign={"center"} className="colFoundText">
              {foundTotal} of {j.length}
            </Typography>
            <UiControls hideRefresh={true} startState={statsState} expand={handleExpand} />
          </Grid>
        </Box>
        <Grid container spacing={{ xs: 4, md: 0 }} className={'juicer'}>
        </Grid>
      </Box>
    );
  }

  if (whichView === 0) {
    return (
      <Box className="inv" onMouseMove={(e) => setMousePos({ x: e.clientX, y: e.clientY })}>
        <Box className="invTitleHolder">
          <Grid container className={'spanRowT quava'} spacing={{ xs: 0 }}>
            <Typography textAlign={"center"} variant="h5" className={'title80'}>
              Collection Log
            </Typography>
            <Typography textAlign={"center"} className="colFoundText">
              {foundTotal} of {j.length}
            </Typography>
            <UiControls hideRefresh={true} startState={statsState} expand={handleExpand} />
          </Grid>
        </Box>
        <Box sx={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Box className="colItemGrid">
            {j.map((_, index) => {
              var displayName = foundLog[index] !== null ? r13(_.toString()).toLowerCase() : "????????????";
              return (
                <Box padding={"6px"} key={index}>
                  <ColItem
                    name={_.toString()}
                    foundName={foundLog[index]}
                    displayName={displayName}
                    hoverCallBack={hoverCallBack}
                    hoverEndCallBack={hoverEndCallBack}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
        {iteminfo.name !== "xxxxxxxxx" && (
          <Box
            className="colPopup"
            style={{ left: mousePos.x + 16, top: mousePos.y + 16 }}
          >
            {iteminfo.name === "????????????" ? (
              <Typography variant="body2" color="#aaaaaa">
                Unclaimed
              </Typography>
            ) : (
              <ItemDetails inputVars={iteminfo} />
            )}
          </Box>
        )}
      </Box>
    );
  } else {
    return (
      <Box className="inv" onMouseMove={(e) => setMousePos({ x: e.clientX, y: e.clientY })}>
        <Grid container className={'spanRowT quava'} spacing={{ xs: 0 }}>
          <Typography textAlign={"center"} variant="h5" className={'title80'}>
            Collection Log
          </Typography>
          <Typography textAlign={"center"} className="colFoundText">
            {foundTotal} of {j.length}
          </Typography>
          <UiControls hideRefresh={true} startState={statsState} expand={handleExpand} />
        </Grid>
        <Box sx={{ height: '60vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Grid container spacing={{ xs: 4, md: 0 }}>
            {j.map((_, index) => {
              if (foundLog[index] !== null) {
                return (
                  <Box padding={"2px"} className={"aColLogLista"} key={index}>
                    {getStringFromIndex(index) + " " + r13(_.toString()).toLowerCase()}
                  </Box>
                );
              } else {
                return (
                  <Box padding={"2px"} className={"aColLogLista graya"} key={index}>
                    {getStringFromIndex(index) + " ??????????"}
                  </Box>
                );
              }
            })}
          </Grid>
        </Box>
        {iteminfo.name !== "xxxxxxxxx" && (
          <Box
            className="colPopup"
            style={{ left: mousePos.x + 16, top: mousePos.y + 16 }}
          >
            {iteminfo.name === "????????????" ? (
              <Typography variant="body2" color="#aaaaaa">
                Unclaimed
              </Typography>
            ) : (
              <ItemDetails inputVars={iteminfo} />
            )}
          </Box>
        )}
      </Box>
    );
  }
};
